import { Controller } from '@hotwired/stimulus';

// Fills the Preview drawer each time it opens, and again on every autosave while it is open.
// Fetched rather than rendered with the page, so it shows what has actually been saved. Reloads
// run one at a time, the next starting only once the current one lands, so the last save wins.
export default class extends Controller {
  static targets = ['frame'];

  static values = { url: String };

  load() {
    this.showing = true;
    if (this.frameTarget.src) this.refresh();
    else this.frameTarget.src = this.urlValue;
  }

  closed() {
    this.showing = false;
  }

  // Fields debounce their save, so one begun just before the drawer opened lands after the
  // preview has already been fetched.
  refresh() {
    if (!this.showing) return;

    // Reloading the frame mid-load aborts the request in flight, which Turbo reports as an
    // AbortError. Queue instead and reload once the running load lands, so the last save wins.
    if (this.loading) this.pending = true;
    else this.reload();
  }

  async reload() {
    this.loading = true;
    this.pending = false;
    await this.frameTarget.reload();
    this.loading = false;
    if (this.pending) this.refresh();
  }

  // Turbo leaves a failed frame showing whatever it had, which on a first open is the spinner.
  failed(event) {
    event.preventDefault();
    this.frameTarget.textContent = 'The preview could not be loaded. Close the drawer and try again.';
  }
}
